import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import { PieChartComponentProps } from './types';

export default makeStyles<ApplicationMuiTheme, PieChartComponentProps>((theme) => ({
    root: {
        width: (props) => (props.width ? `${props.width}px` : '100%'),
        height: (props) => (props.height ? `${props.height}px` : 'auto' as const),
        position: 'relative' as const,
        '& .main-svg': {
            boxSizing: 'border-box' as const,
            borderRadius: ({ rootStyles }) => rootStyles?.borderRadius ? `${rootStyles.borderRadius}px` : 0,
            border: ({ rootStyles }) => rootStyles?.borderColor ?
                `solid 1px ${rootStyles.borderColor}`
                : 'none' as const
        }
    },
    caption: {
        position: 'absolute' as const,
        left: 16,
        bottom: 2,
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontSize: '12px'
    }
}));